/**
 * Formats a Price value as a currency string, using the specified Locale and Currency.
 *
 * @param {number} price - The Price value to be formatted.
 * @param {string} priceCurrency - The Currency code (e.g., 'USD', 'EUR') to be used in formatting.
 * @param {string} locale - The Locale code (e.g., 'en-US', 'de-DE') to be used for formatting.
 * @returns {string} The formatted currency string.
 *
 * @example
 * // Returns '$100' for the US locale
 * formatPrice(100, 'USD', 'en-US');
 *
 * // Returns '€99,95' for the German locale
 * formatPrice(99.95, 'EUR', 'de-DE');
 */
export default function formatPrice(price, priceCurrency, locale) {
  const fractionDigits = price % 1 === 0 ? 0 : 2;

  return new Intl.NumberFormat(locale, {
    style: 'currency',
    currency: priceCurrency,
    currencyDisplay: 'narrowSymbol',
    minimumFractionDigits: fractionDigits,
    maximumFractionDigits: fractionDigits
  }).format(price);
}
